import { render, staticRenderFns } from "./EndSave.vue?vue&type=template&id=770c2134&"
import script from "./EndSave.vue?vue&type=script&lang=js&"
export * from "./EndSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports